module.exports = __webpack_public_path__ + "img/2009-3.ede3dd39.jpg";